import React from "react";
import { Route, Redirect } from "react-router";
import { connect } from "react-redux";
import { setSessionStorage, removeSessionStorage } from "../utils/storageUtils";
import { TRIAL_SESSION_KEY, TRIAL_URL_PATH } from "../utils/constants";

function checkFreeTrialRoute(routeUrl) {
  if (routeUrl === TRIAL_URL_PATH) {
    setSessionStorage(TRIAL_SESSION_KEY, true);
  } else {
    removeSessionStorage(TRIAL_SESSION_KEY)
  }
}

const AuthRoute = ({
  component: Component,
  isAuthenticated,
  user,
  ...rest
}) => {

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated && user && user.userType) {
          if (user.isRegistered) {
            if (user.userType === "group") {
              if (
                (user.permissions.includes("group_subscription") &&
                  user.permissions.includes("passcode_trial")) ||
                (user.permissions.length === 1 &&
                  user.permissions.includes("group_subscription"))
              ) {
                return <Component {...props} />;
              } else if (
                user.permissions.includes("group_subscription") &&
                user.permissions.includes("passcode_trial_expired")
              ) {
                return (
                  <Redirect
                    to={{
                      pathname: "/auth/trial-expired",
                      state: { from: props.location },
                    }}
                  />
                );
              }
            }

            if (user.userType === "subscribed") {
              return <Component {...props} />;
            }

            if (
              user.userType === "not_subscribed" &&
              user.permissions.includes("can_buy_subscription")
            ) {
              return (
                <Redirect
                  to={{
                    pathname: "/auth/trial-expired",
                    state: { from: props.location },
                  }}
                />
              );
            }
          } else {
            return (
              <Redirect
                to={{
                  pathname: "/auth/complete-profile",
                  state: { from: props.location },
                }}
              />
            );
          }
        } else {
          const { location } = props, { pathname } = location || {};
          if (pathname)
            checkFreeTrialRoute(pathname);
          return (
            <Redirect
              to={{
                pathname: "/auth/login",
                state: { from: props.location },
              }}
            />
          );
        }
      }}
    />
  );
};

const mapStateToProps = ({ auth: { isAuthenticated, user } }) => ({
  isAuthenticated,
  user,
});

export default connect(mapStateToProps)(AuthRoute);
